<template>
  <div class='frameMain'>
    <component-header></component-header>
    <component-board></component-board>
    <component-footer></component-footer>
  </div>
</template>

<script>
import ComponentHeader from ".././Header/PageHeader.vue";
import ComponentBoard from ".././Board/PageBoard.vue";
import ComponentFooter from ".././Footer/PageFooter.vue";

export default {
  name: 'page-frame',
  components:{
    ComponentHeader,
    ComponentBoard,
    ComponentFooter,
  },
  data () {
    return{
      
    }
  },
  methods: {

  }
}
</script>

<style scoped>
</style>